import { BannerVariant } from './Banner.js';

var _a;
var bannerVariantToButtonStyling = (_a = {},
    _a[BannerVariant.Primary] = {
        buttonVariant: 'primary',
        buttonBackground: 'elevation',
    },
    _a[BannerVariant.PrimaryAlt] = {
        buttonVariant: 'primary-alt',
        buttonBackground: 'elevation',
    },
    _a[BannerVariant.Secondary] = {
        buttonVariant: 'primary',
        buttonBackground: 'color',
    },
    _a[BannerVariant.SecondaryAlt] = {
        buttonVariant: 'primary-alt',
        buttonBackground: 'color',
    },
    _a[BannerVariant.SecondaryAlt2] = {
        buttonVariant: 'primary',
        buttonBackground: 'color',
    },
    _a[BannerVariant.Tertiary] = {
        buttonVariant: 'primary',
        buttonBackground: 'elevation',
    },
    _a[BannerVariant.TertiaryAlt] = {
        buttonVariant: 'primary',
        buttonBackground: 'color',
    },
    _a[BannerVariant.NapoleonPrimary] = {
        buttonVariant: 'primary',
        buttonBackground: 'color',
    },
    _a[BannerVariant.NapoleonSecondary] = {
        buttonVariant: 'primary',
        buttonBackground: 'elevation',
    },
    _a);

export { bannerVariantToButtonStyling };
